import { render, staticRenderFns } from "./project_import.vue?vue&type=template&id=b2087550&scoped=true&"
import script from "./project_import.vue?vue&type=script&lang=js&"
export * from "./project_import.vue?vue&type=script&lang=js&"
import style0 from "./project_import.vue?vue&type=style&index=0&id=b2087550&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2087550",
  null
  
)

/* custom blocks */
import block0 from "./project_import.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports